<template>
	<div class="fileadministrationTable">
		<div class="Btns">
			<div style="margin-left: 13px;" v-if="activeTab === '采购指标'">
				<Commonbtn backgroundColor="#FFF" title="采购指标确认上传" fontSize="14px" @btnclick="ProcurementIndicators"
					:src="require('@/assets/channel/ProcurementIndicators.png')">
				</Commonbtn>
			</div>
		</div>
		<div class="" :style="{ marginLeft: '13px', padding: activeTab === '授权书' ? '24px 0px' : '0px' }">
			<Commontable @onRowClick="onRowClick" width="1156px" colnum=7 :tableData="tableData"
				:headerData="headerData" height="100%" @operationDownload="operationDownload" @reasonTips="reasonTips">
			</Commontable>
		</div>

		<DialogFrom width="500px" :title="TitleDialog" rigthText="提交采购指标" :dialogVisible="dialogVisibDialogAll"
			@cancel="cancelDialogAll" @dialogOK="dialogOKDialogAll">
			<div style="margin-left: -10px;">
				<CommonbtnUpLoad types='UploadAll' style="display: inline-block;margin-top: 10px;"
					backgroundColor="#FFF" title="上传采购指标" fontSize="14px" @getFile="UpLoadProcurementIndicators"
					:src="require('@/assets/icon/icon-drjys.png')">
				</CommonbtnUpLoad>
			</div>
			<FilesAndPictures :DelFlag="false" v-for="(item , index) of lstAttachment" :key="index"
				:fileAddImgData="item" @See="See"></FilesAndPictures>
		</DialogFrom>
		<Picturepreview :imgsrc="imgsrc" :show="imgShow" @hidefn="imgHide"></Picturepreview>
	</div>

</template>

<script>
	import Commontable from '@/components/common-table.vue'
	import Pagination from '@/components/pagination.vue'
	import headerData from '../headerData/headerData'
	import Commonbtn from '@/components/common-btn.vue'
	import DialogFrom from '@/components/dialog-from.vue'
	import CommonbtnUpLoad from '@/components/common-upload.vue'
	import FilesAndPictures from '@/components/FilesAndPictures.vue'
	import Picturepreview from '@/components/picturepreview.vue'
	import utils from '../../../../../common/utils'
	import {
		CustomerQuotaUpLoadAttachment,
		CustomerQuotaAddAtachment,
		FileManageDownloadFile
	} from '@/api/channel'
	export default {
		name: 'FileadministrationTable',
		components: {
			Commontable,
			Pagination,
			Commonbtn,
			DialogFrom,
			FilesAndPictures,
			CommonbtnUpLoad,
			Picturepreview
		},
		props: {
			tableData: {
				type: Array
			},
			activeTab: {
				type: String,
				default: '授权书'
			}
		},
		data() {
			return {
				dialogVisibDialogAll: false,
				imgShow: false,
				TitleDialog: '加载中...',
				imgsrc: '',
				headerData: [],
				lstAttachment: [],
				RowData: null
			}
		},
		created() {},
		mounted() {
			this.initHeader()
		},
		activated() {},
		updated() {},
		methods: {
			initHeader() {
				let baseHeader = JSON.parse(JSON.stringify(headerData))
				// 移除“文件类型”列，因为标签页已经区分了类型
				baseHeader = baseHeader.filter(item => item.prop !== 'FileType')

				if (this.activeTab === '授权书') {
					// 在“文件名”列后插入“医院名称”
					baseHeader.splice(2, 0, {
						prop: "HospitalName",
						label: "医院名称",
						columnwidth: 200,
					})
				} else if (this.activeTab === '采购指标') {
					// 查找“单据号”所在索引并修改为“状态”，同时在其前面插入“全年指标(不含税)”
					let statusIndex = baseHeader.findIndex(item => item.label === '单据号' || item.prop === 'Code');
					if (statusIndex !== -1) {
						baseHeader[statusIndex].label = '状态'
						baseHeader[statusIndex].prop = 'StatusName'
						baseHeader[statusIndex].columnwidth = 120

						baseHeader.splice(statusIndex, 0, {
							prop: "YearQuota",
							label: "全年指标(不含税)",
							columnwidth: 180,
						})
					}
				}
				this.headerData = baseHeader
			},
			reasonTips(e) {
				this.$alert(e.RejectReason, '提示', {
					confirmButtonText: '确定',
					callback: action => {}
				});
			},
			onRowClick(val) {
				this.RowData = val
			},
			imgHide() {
				this.imgShow = false
			},
			See(par) {
				console.log(par);
				if (par.Extension == 'jpg' || par.Extension == 'png' || par.Extension == 'gif') {
					this.imgShow = true
					this.imgsrc = par.FileUrl
				} else if (par.Extension == 'pdf') {
					window.open(par.FileUrl, '_blank')
				} else {
					window.location.href = par.FileUrl
				}
			},
			ProcurementIndicators() {
				if (!this.RowData) {
					this.$message.warning('请选择您要操作的数据！')
				} else {
					this.TitleDialog = '采购指标'
					this.dialogVisibDialogAll = true
				}
			},
			// 上传采购指标接口
			async CustomerQuotaUpLoadAttachment(file) {
				const loading = this.$loading({
					lock: true,
					text: '上传中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formData = new FormData()
				formData.append("file", file)
				let res = await CustomerQuotaUpLoadAttachment(formData)
				if (res.code == 0) {
					this.$message({
						type: 'success',
						message: res.message
					})
					this.lstAttachment = []
					this.lstAttachment.push(res.data)
				} else if (res.code == 101) {
					this.$message({
						type: 'warning',
						message: res.message
					})
				} else {
					this.$message({
						type: 'error',
						message: res.message
					})
				}
				loading.close();
			},

			UpLoadProcurementIndicators(file) {
				this.CustomerQuotaUpLoadAttachment(file)
			},
			// 提交
			async CustomerQuotaAddAtachment() {
				let {
					code,
					message,
					data
				} = await CustomerQuotaAddAtachment({
					InfoID: this.RowData.InfoID,
					FileName: this.lstAttachment[0].FileName
				})
				if (code == 0) {
					this.dialogVisibDialogAll = false
					this.$parent.FileManageList()
					this.$message.success('提交成功')
				} else {
					this.$message.warning(message)
				}
			},
			// 下载
			async FileManageDownloadFile(row) {
				let res = await FileManageDownloadFile({
					InfoID: row.InfoID
				})
				console.log(res);
				if (res.status == 200) {
					utils.downloadFile(res.data, `${row.Title}-${row.CreateTime.substring(0, 10)}`, 'pdf');
				} else {
					this.$message.warning('下载失败')
				}
			},
			// 行下载事件
			operationDownload(row) {
				console.log(row);
				if (row.Attachment.Extension) {
					if (row.Attachment.Extension == 'pdf') {
						window.open(row.Attachment.FileUrl, '_blank')
						return
					}
					window.location.href = row.Attachment.FileUrl
				} else {
					this.FileManageDownloadFile(row)
				}

			},
			cancelDialogAll() {
				this.dialogVisibDialogAll = false
			},
			dialogOKDialogAll() {
				this.CustomerQuotaAddAtachment()
			}

		},
		computed: {},
		watch: {
			dialogVisibDialogAll: {
				handler(newVal, oldVal) {
					if (newVal) {
						this.lstAttachment = []
					}
				}
			},
			activeTab: {
				handler() {
					this.initHeader()
				}
			}
		},
	}
</script>
<style scoped lang='less'>
	.Btns {
		width: 100%;
		// border: 1px solid red;
		display: flex;
		justify-content: flex-start;
	}

	.fileadministrationTable {
		width: 100%;
		max-height: 400px;
		// margin-top: 25px;


		.Table {
			margin-left: -10px;
		}
	}
</style>